import React, { useState } from "react";
import Loading from "../../../../../../components/Loading/Loading";
import localeText from "../../../../../../locale";
import { formatExtrapayDateTime } from "../formatExtrapay";
import ConversionDetailsDialog, {
  formatConversionExc,
  getConversionTitle,
} from "./ConversionDetailsDialog";
import ExtrapayTable from "./ExtrapayTable";

const ExcStatementTable = ({ conversions = [], isLoading }) => {
  const [selected, setSelected] = useState(null);

  if (isLoading) {
    return (
      <div className="flex justify-content-center py-4">
        <Loading classNameIcon="text-4xl" />
      </div>
    );
  }

  const columns = [
    {
      key: "movement",
      header: localeText("extrapayFlowMovement"),
      render: (row) => getConversionTitle(row),
    },
    {
      key: "date",
      header: localeText("extrapayFlowDate"),
      render: (row) => formatExtrapayDateTime(row.date),
    },
    {
      key: "exc",
      header: "EXC",
      render: (row) => formatConversionExc(row.tokensReceived, { signed: true }),
    },
    {
      key: "details",
      header: "",
      render: (row) => (
        <button
          type="button"
          className="p-0 border-none bg-transparent cursor-pointer"
          style={{ color: "#335CFF" }}
          onClick={() => setSelected(row)}
        >
          {localeText("extrapayFlowViewDetails")}
        </button>
      ),
    },
  ];

  return (
    <>
      <ExtrapayTable
        columns={columns}
        rows={conversions}
        emptyMessage={localeText("extrapayFlowExcEmpty")}
        rowKey={(row) => row.id}
      />
      <ConversionDetailsDialog conversion={selected} onHide={() => setSelected(null)} />
    </>
  );
};

export default ExcStatementTable;
